import { isDocumentFilled, prismicClient } from '@/data';
import { usePrismicStaleTime } from '@/data/prismicHooks';
import { useActiveProductConfig } from '@/hooks/use-active-product';
import { WhatsNewCardDocument } from '@/types/prismic.generated';
import { FilledContentRelationshipField } from '@prismicio/client';
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';

type Props = ['whats_new', string | undefined];

export type WhatsNewCardData = FilledContentRelationshipField<
    'whats_new_card',
    string,
    WhatsNewCardDocument['data']
> & { data: WhatsNewCardDocument['data'] };

const fetcher = async (context: QueryFunctionContext<Props>) => {
    const [key, whatsNewUid] = context.queryKey;
    const whatsNew = await prismicClient.getByUID(key, whatsNewUid ?? '', {
        graphQuery: `{
            whats_new {
                ...whats_newFields
                whats_new_cards {
                    card {
                        ...cardFields
                    }
                }
            }
        }`,
    });

    const cards = (whatsNew.data.whats_new_cards ?? [])
        .map(item => item.card)
        .filter(card => isDocumentFilled(card) && card.data != null) as WhatsNewCardData[];

    return { ...whatsNew.data, cards };
};

export const useWhatsNewData = () => {
    const productConfig = useActiveProductConfig();
    const staleTime = usePrismicStaleTime();
    return useQuery({
        queryKey: ['whats_new', productConfig?.whatsNewUid],
        queryFn: fetcher,
        staleTime,
    });
};
